import { Injectable } from '@angular/core';

import { ConfirmNewPasswordPayload } from '@modules/core/interfaces';
import { UpdatePasswordRequestDTO } from '@paymash/sdk/dto/request';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordMapper {
  public mapToDTO(entity: ConfirmNewPasswordPayload): UpdatePasswordRequestDTO {
    return {
      password: entity.password
    };
  }
}